import {inject, Inject, Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {WebmateOptions} from '@webmate-web-core/webmate-options';

import {FeatureService} from '@webmate-web-core/shared/services/feature.service';
import {map, mergeMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {UserService} from '@webmate-web-core/shared/services/user.service';
import {ManageProjectsPermission, ProjectAdmin} from '@webmate-web-core/shared/constants/permission.constants';
import {has} from 'lodash';
import {generateFallbackRoute} from '@webmate-web-core/shared/guards/route-guard-utils';

export const adminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const userService = inject(UserService);
    const router = inject(Router);

    return userService.getCurrentUserData().pipe(map(user => user.administrativePermissions.length > 0 ? true : generateFallbackRoute(state, route, router, '/')));
};

export const projectAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    let projectId = route.pathFromRoot.find(s => !!s.params['projectId'])?.params['projectId'];
    if (!projectId) {
        throw new Error('No projectId in current route found');
    }
    const userService = inject(UserService);
    const router = inject(Router);
    return userService.hasPermissionInProject(projectId, ProjectAdmin)
        .pipe(mergeMap(hasPermission => hasPermission ? of(hasPermission) : userService.hasAdminPermission(ManageProjectsPermission)
                .pipe(map(manageProjectsPermission => hasPermission || manageProjectsPermission))),
            map(hasPermission => hasPermission ? true : generateFallbackRoute(state, route, router)));
};

export const wmAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const userService = inject(UserService);
    const router = inject(Router);

    return userService.getCurrentUserData().pipe(map(user => user.isWebmateAdmin ? true : generateFallbackRoute(state, route, router, '/')));
};

